/**
 * Rotating "proof" line at the bottom of the login glass card. Cycles
 * through the array every 8s with a 600ms cross-fade. Absolutely
 * positioned so opacity transitions don't shift the card height.
 */

import React, { useEffect, useState } from 'react';

export interface Proof {
  text: string;
  cta: string;
}

interface ProofLineProps {
  items: Proof[];
  intervalMs?: number;
}

const ProofLine: React.FC<ProofLineProps> = ({ items, intervalMs = 8000 }) => {
  const [i, setI] = useState(0);

  useEffect(() => {
    if (items.length <= 1) return;
    const id = setInterval(() => {
      setI(prev => (prev + 1) % items.length);
    }, intervalMs);
    return () => clearInterval(id);
  }, [items.length, intervalMs]);

  return (
    <div className="proof-line" aria-live="polite">
      {items.map((p, idx) => (
        <div
          key={idx}
          className={`proof-signal${idx === i ? ' active' : ''}`}
          aria-hidden={idx === i ? undefined : true}
        >
          {p.text} <span className="gl">{p.cta}</span>
        </div>
      ))}
    </div>
  );
};

export default ProofLine;
